<template>
  <section class="mx-5 mb-6">
    <v-row>
      <v-col cols="6" md="6" sm="12">
        <v-card outlined class="flex-grow-1 v-chart-col fill-height elevation-0">
          <div class="d-flex align-center justify-space-between mr-5"> 
            <v-card-title>{{ $t('portfolioAnalytics.stressTest') }}</v-card-title>
            <!-- <base-button isActive>
              <v-icon>mdi-arrow-expand</v-icon>
            </base-button> -->
          </div>

          <v-card-subtitle>
            {{ $t('portfolioAnalytics.contributionToCvar') }}
          </v-card-subtitle>

          <div class="d-flex justify-space-between mx-5">
            <h5 class="cvar-plus">{{ $t('portfolioAnalytics.cvarPlus') }} 0.00%</h5>
            <h5 class="expected">{{ $t('portfolioAnalytics.expected') }} 0.00%</h5>
            <h5 class="cvar-neg">{{ $t('portfolioAnalytics.cvarNeg') }} 0.00%</h5>
          </div>
          <v-chart :option="stressTest" style="height: 25vh" autoresize />
        </v-card>
      </v-col>

      <v-col cols="6" md="6"  sm="12">
        <v-card outlined class="flex-grow-1 risk-attribution fill-height elevation-0">
          <div class="d-flex align-center justify-space-between mr-5"> 
            <v-card-title>
              {{ $t('portfolioAnalytics.riskAttributionLiquidity') }}
            </v-card-title>
            <!-- <base-button isActive>
              <v-icon>mdi-arrow-expand</v-icon>
            </base-button> -->
          </div>

          <v-row align="center" class="d-flex  justify-space-around">
            <v-col lg="8" md="12" sm="5">
              <h5>{{ $t('portfolioAnalytics.liquidityFactors') }}</h5>
            </v-col>
            <v-cols lg="3" md="12" sm="12">
              <h5>0.00% / 0.00%</h5>
            </v-cols>
          </v-row>

          <v-row
            v-for="(item, i) in factors"
            :key="i"
            align="center"
            class="px-6 d-flex"
          >
            <v-col lg="6" md="12" sm="5" class="text-left min-w-0">
              <h5>{{ item.label }}</h5>
            </v-col>

            <v-col lg="4" md="12" class="d-flex">
              <v-progress-linear
                height="12"
                v-model="item.value"
                color="#ffbf00"
                style="border-radius: 999px; flex-grow: 1;"
                background-color="#292929"
              ></v-progress-linear>
            </v-col>
            <v-col lg="2" md="12" class="text-right">
              <h5>{{ item.value }}%</h5>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-card outlined class="elevation-0">
          <div class="d-flex align-center justify-space-between mr-5"> 
            <v-card-title>
              {{ $t('portfolioAnalytics.backtestWeekly') }}
            </v-card-title>
            <!-- <base-button isActive>
              <v-icon>mdi-arrow-expand</v-icon>
            </base-button> -->
          </div>
          <v-chart :option="backTest" autoresize style="height: 36vh"></v-chart>
        </v-card>
      </v-col>
    </v-row>
  </section>
</template>

<script>
import VChart from "vue-echarts";
import { use } from "echarts/core";
import * as echarts from "echarts";
import { BarChart, LineChart } from "echarts/charts";
import {
  TooltipComponent,
  TitleComponent,
  ToolboxComponent,
  GridComponent,
  DataZoomComponent,
} from "echarts/components";
import { CanvasRenderer } from "echarts/renderers";

use([
  TooltipComponent,
  TitleComponent,
  ToolboxComponent,
  GridComponent,
  DataZoomComponent,
  BarChart,
  LineChart,
  CanvasRenderer,
]);
export default {
  components: {
    VChart,
  },
  data() {
    return {
      chartOptions: {
        title: {
          text: "Dummy Bar Chart",
        },
        tooltip: {},
        xAxis: {
          type: "category",
          data: ["A", "B", "C", "D", "E", "F"],
        },
        yAxis: {
          type: "value",
        },
        series: [
          {
            name: "Values",
            type: "bar",
            data: [120, 200, 150, 80, 70, 110],
            itemStyle: {
              color: "#4ea397",
            },
          },
        ],
      },
    };
  },
  computed: {
    factors() {
      return [
        { label: this.$t('portfolioAnalytics.factors.volatility'), value: 0 },
        { label: this.$t('portfolioAnalytics.factors.cumVolatility'), value: 0 },
        { label: this.$t('portfolioAnalytics.factors.cumPostContribution'), value: 0 },
      ];
    },
    stressTest() {
      const categories = [
        this.$t('portfolioAnalytics.days.mon'),
        this.$t('portfolioAnalytics.days.tue'),
        this.$t('portfolioAnalytics.days.wed'),
        this.$t('portfolioAnalytics.days.thu'),
        this.$t('portfolioAnalytics.days.fri'),
        this.$t('portfolioAnalytics.days.sat'),
        this.$t('portfolioAnalytics.days.sun'),
      ];
      const values = [ ];
      // const values = [120, -132, 101, -134, 90, -230, -210];

      const options = {
        tooltip: {
          trigger: "axis",
        },
        xAxis: {
          type: "category",
          data: categories,
        },
        yAxis: {
          type: "value",
        },
        series: [
          {
            name: this.$t('portfolioAnalytics.series.values'),
            type: "bar", // <-- now it’s a bar chart
            data: values,
            itemStyle: {
              color: "#26c281",
            },
            barWidth: "60%",
          },
        ],
      };

      return options;
    },
    backTest() {
      const categories = [
        this.$t('portfolioAnalytics.days.mon'),
        this.$t('portfolioAnalytics.days.tue'),
        this.$t('portfolioAnalytics.days.wed'),
        this.$t('portfolioAnalytics.days.thu'),
        this.$t('portfolioAnalytics.days.fri'),
        this.$t('portfolioAnalytics.days.sat'),
        this.$t('portfolioAnalytics.days.sun'),
      ];
      const values = [ ];
      // const values = [120, -132, 101, -134, 90, -230, -210];

      const options = {
        tooltip: {
          trigger: "axis",
        },
        xAxis: {
          type: "category",
          data: categories,
        },
        yAxis: {
          type: "value",
        },
        series: [
          {
            name: this.$t('portfolioAnalytics.series.benchmark'),
            type: "line",
            smooth: true,
            lineStyle: {
              color: "#26c281",
            },
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: "rgba(38, 194, 129, 1)" }, // top
                { offset: 1, color: "rgba(38,194,129,0)" }, // bottom
              ]),
            },
            data: values,
            itemStyle: {
              color: "#26c281",
            },
            barWidth: "60%",
          },
          {
            name: this.$t('portfolioAnalytics.series.portfolio'),
            type: "line",
            smooth: true,
            lineStyle: {
              color: "#ff8a3d",
            },
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: "rgba(229, 83, 83,0.8)" }, // top
                { offset: 1, color: "rgba(229, 83, 83, 0)" }, // bottom
              ]),
            },
            data: [],
            // data: [50, 80, -60, 90, -40, -70, 100],
            itemStyle: {
              color: "#ff8a3d",
            },
            barWidth: "60%",
          },
        ],
      };

      return options;
    },
  },
};
</script>5

<style scoped>

.risk-attribution {
  line-height: clamp(.4rem, 2vw, 1.3rem);
  font-size: clamp(.4rem, 1.5vw, 1.3rem);
  padding-bottom:4.5rem;
}



.cvar-plus {
  color: var(--success);
}

.cvar-neg {
  color: var(--danger);
}

.expected {
  color:var(--muted)
}
</style>
